import { Box, Table, Text } from '@factorialco/deprecated-design-system'

interface Props {
  label: string
}

const QuestionHeadCell = ({ label }: Props) => {
  return (
    <Table.Row>
      <Table.Cell key={1}>
        <Box textAlign="left" justifyContent="center">
          <Text htmlTag="h2" weight="semibold" size="400" color="grey1000">
            {label}
          </Text>
        </Box>
      </Table.Cell>
      <Table.Cell key={2}>
        <Box textAlign="right">
          <Text.Normal weight="semibold" htmlTag="p" whiteSpace="breakSpaces"></Text.Normal>
        </Box>
      </Table.Cell>
    </Table.Row>
  )
}

export default QuestionHeadCell
